import { enum_to_hash } from "../helpers.js"

const status = {
	UNKNOWN: 0,
	DRAFT: 1,
	CONFIRMED: 10,
	PICKING: 11,
	SEPARATED: 12,
	IN_TRANSIT: 20,
	SUPERVISORY_ORGAN: 21,
	IN_TRANSIT_ORIGIN: 22,
	IN_TRANSIT_DESTINATION: 23,
	PENDING_CLIENT: 30,
	PENDING_PAYMENT: 80,
	IN_ANALYSIS: 40,
	CANCELED_CLIENT: 90,
	BLOCKED: 96,
	FINALIZED: 97,
	CANCELED: 98,
	DELIVERED: 99
}

export default status

export const options = [
	{ id: 0, shipment_status: 0, text: "UNKNOWN", label: "shipment_status.UNKNOWN", class: "bg-gray-100 fill-gray-100", filter_tab: false },
	{ id: 1, shipment_status: 1, text: "DRAFT", label: "shipment_status.DRAFT", class: "bg-gray-100 fill-gray-300", filter_tab: true },
	{ id: 40, shipment_status: 40, text: "IN_ANALYSIS", label: "shipment_status.IN_ANALYSIS", class: "bg-yellow-100 text-yellow-800 fill-yellow-600", filter_tab: true },
	{ id: 10, shipment_status: 10, text: "CONFIRMED", label: "shipment_status.CONFIRMED", class: "bg-yellow-100 text-yellow-800 fill-yellow-600", filter_tab: true },
	{ id: 11, shipment_status: 11, text: "PICKING", label: "shipment_status.PICKING", class: "bg-green-100 text-green-700 fill-green-700", filter_tab: true },
	{ id: 12, shipment_status: 12, text: "SEPARATED", label: "shipment_status.SEPARATED", class: "bg-blue-100 text-blue-700 fill-blue-700", filter_tab: true },
	{ id: 20, shipment_status: 20, text: "IN_TRANSIT", label: "shipment_status.IN_TRANSIT", class: "bg-blue-100 text-blue-700 fill-blue-700", filter_tab: true },
	{ id: 22, shipment_status: 22, text: "IN_TRANSIT_ORIGIN", label: "shipment_status.IN_TRANSIT_ORIGIN", class: "bg-blue-100 text-blue-700 fill-blue-700", filter_tab: false },
	{ id: 23, shipment_status: 23, text: "IN_TRANSIT_DESTINATION", label: "shipment_status.IN_TRANSIT_DESTINATION", class: "bg-blue-100 text-blue-700 fill-blue-700", filter_tab: false },
	{ id: 21, shipment_status: 21, text: "SUPERVISORY_ORGAN", label: "shipment_status.SUPERVISORY_ORGAN", class: "bg-yellow-100 text-yellow-800 fill-yellow-600", filter_tab: true },
	{ id: 30, shipment_status: 30, text: "PENDING_CLIENT", label: "shipment_status.PENDING_CLIENT", class: "bg-yellow-100 text-yellow-800 fill-yellow-600", filter_tab: false },
	{ id: 80, shipment_status: 80, text: "PENDING_PAYMENT", label: "shipment_status.PENDING_PAYMENT", class: "bg-yellow-100 text-yellow-800 fill-yellow-600", filter_tab: false },
	{ id: 90, shipment_status: 90, text: "CANCELED_CLIENT", label: "shipment_status.CANCELED_CLIENT", class: "bg-red-100 text-red-700 fill-red-700", filter_tab: false },
	{ id: 97, shipment_status: 96, text: "BLOCKED", label: "shipment_status.BLOCKED", class: "bg-red-100 text-red-700 fill-red-700", filter_tab: false },
	{ id: 97, shipment_status: 97, text: "FINALIZED", label: "shipment_status.FINALIZED", class: "bg-red-100 text-red-700 fill-red-700", filter_tab: false },
	{ id: 98, shipment_status: 98, text: "CANCELED", label: "shipment_status.CANCELED", class: "bg-red-100 text-red-700 fill-red-700", filter_tab: false },
	{ id: 99, shipment_status: 99, text: "DELIVERED", label: "shipment_status.DELIVERED", class: "bg-green-100 text-green-70 fill-green-700", filter_tab: true }
]

export const manifestable_status = [
	status.CONFIRMED
]
export const trackable_status = [10, 11, 12, 20, 21, 22, 23]

export const hash = enum_to_hash(options)